import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MapVisibilityService {
  private isMapVisible = false;

  constructor() {
  }

  set IsMapVisible(value: boolean) {
    this.isMapVisible = value;
  }

  get IsMapVisible(): boolean {
    return this.isMapVisible;
  }
}
